import React from "react";

const AppVersion = () => <small>(v.4.5.9)</small>;

export default AppVersion;
